import { Box, Switch, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';

import { LightTooltip } from '../WhiteTooltip';

export interface SimulationBannerProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  sx?: SxProps<Theme>;
}

const SimulationBanner: React.FC<SimulationBannerProps> = ({
  checked,
  onChange,
  sx = {},
}) => {
  return (
    <LightTooltip
      title={
        <Typography padding={1}>
          {checked
            ? 'Simulación: Simula las condiciones de la solicitud usando documentos ficticios.'
            : 'Modo normal: Simula las condiciones de la solicitud usando documentos reales.'}
        </Typography>
      }
      placement="top"
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 1,
          px: 2,
          mt: 1,
          ...sx,
        }}
      >
        <Switch
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          size="small"
        />
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            color: 'text.primary',
          }}
        >
          {checked ? 'Simulación' : 'Modo normal'}
        </Typography>
      </Box>
    </LightTooltip>
  );
};

export default SimulationBanner;
